import { useFetchCallType } from '@rahtab/auth/lib/token-based-auth';
import { useEffect, useState } from 'react';

export const useProvinces = ({ skip = false, selectedCounty, selectedProvince }: ProvinceArg = { skip: false }) => {
  const [changeDataLoading, setChangeDataLoading] = useState(false);
  const [provinces, setProvinces] = useState<Province[]>([]);
  const [counties, setCounties] = useState<County[]>([]);
  const [cities, setCities] = useState<Data[]>([]);
  const [_, { loading }] = useFetchCallType<ServerProvinceResponse>('GetProvincesInfo', {
    skip,
    onCompleted: (provincesCitiesCountiesData) => {
      let tempProvinces: Province[] = [];
      provincesCitiesCountiesData.Provinces.forEach((province) => {
        let tempCounties: County[] = [];
        province.Counties.forEach((county) => {
          const tempCities: Data[] = [];
          county.Cities.forEach((city) => {
            tempCities.push({ label: city.CityName, value: city.CityName });
          });
          tempCounties.push({
            cities: tempCities,
            label: county.CountyName,
            value: county.CountyName,
          });
        });
        tempProvinces.push({
          counties: tempCounties,
          label: province.ProvinceName,
          value: province.ProvinceName,
        });
      });
      setProvinces(tempProvinces);
    },
  });
  useEffect(() => {
    selectedProvince && provinces.length > 0 && selectProvince(selectedProvince);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [provinces, selectedProvince]);
  useEffect(() => {
    selectedCounty && counties.length > 0 && selectCounty(selectedCounty);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [counties, selectedCounty]);
  const selectProvince = (province: string) => {
    setChangeDataLoading(true);
    provinces.forEach((pro) => {
      if (pro.value === province) {
        const tempCounties: County[] = [];
        pro.counties.forEach((c) => {
          tempCounties.push(c);
        });
        setCounties(tempCounties);
        setChangeDataLoading(false);
        return;
      }
    });
    setChangeDataLoading(false);
  };
  const selectCounty = (county: string) => {
    setChangeDataLoading(true);
    counties.forEach((coun) => {
      if (coun.value === county) {
        const tempCounties: Data[] = [];
        coun.cities.forEach((c) => {
          tempCounties.push(c);
        });
        setCities(tempCounties);
        setChangeDataLoading(false);
        return;
      }
    });
    setChangeDataLoading(false);
  };
  return {
    provinces,
    counties,
    cities,
    changeDataLoading,
    getProvincesLoading: loading,
  };
};

export interface Data {
  label: string;
  value: string;
}
export interface County extends Data {
  cities: Data[];
}
export interface Province extends Data {
  counties: County[];
}
interface ServerCity {
  CityName: string;
}
interface ServerCounty {
  CountyName: string;
  Cities: ServerCity[];
}
interface ServerProvince {
  ProvinceName: string;
  Counties: ServerCounty[];
}
interface ServerProvinceResponse {
  Provinces: ServerProvince[];
}
export interface ProvinceArg {
  selectedProvince?: string;
  selectedCounty?: string;
  skip?: boolean;
}
